<div *ngIf="passwordForm" class="change-password-dialog__content">
  <p class="change-password-dialog__content_title">
    {{ 'CHANGE_PASSWORD.TITLE' | translate }}
  </p>

  <form [formGroup]="passwordForm" novalidate autocomplete="off" class="change-password-dialog__content__form">
    <div class="field-outline-form" fxLayout="column" fxLayoutGap="20px" fxLayoutAlign="start start">
      <mat-form-field *ngIf="userType === 'AuthenticatedUser'" appearance="outline" fxFlex="100">
        <mat-label>
          {{ 'CHANGE_PASSWORD.CURRENT' | translate }}
        </mat-label>
        <input
          matInput
          required
          name="password"
          formControlName="currentPassword"
          autocomplete="off"
          [type]="showPassword ? 'text' : 'password'"
        />

        <button
          mat-icon-button
          matSuffix
          class="change-password-dialog__content__form_suffix"
          (click)="$event.preventDefault(); showPassword = !showPassword"
          [matTooltip]="(showPassword ? 'CHANGE_PASSWORD.HIDE' : 'CHANGE_PASSWORD.SHOW') | translate"
          [matTooltipPosition]="'right'"
          type="button"
          tabindex="-1"
        >
          <mat-icon>{{ showPassword ? 'visibility' : 'visibility_off' }}</mat-icon>
        </button>

        <mat-error *ngIf="passwordForm.get('currentPassword').hasError('required')">
          {{ 'CHANGE_PASSWORD.ERRORS.REQUIRED' | translate }}
        </mat-error>

        <mat-error *ngIf="passwordForm.get('currentPassword').hasError('invalid')">
          {{ 'CHANGE_PASSWORD.ERRORS.INVALID' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" fxFlex="100">
        <mat-label *ngIf="isOnEditDialog">
          {{ 'CHANGE_PASSWORD.NEW' | translate }}
        </mat-label>
        <mat-label *ngIf="!isOnEditDialog">
          {{ 'CHANGE_PASSWORD.PASSWORD' | translate }}
        </mat-label>
        <input
          matInput
          [type]="showNewPassword ? 'text' : 'password'"
          formControlName="password"
          required
          autocomplete="new-password"
          name="new-password-to-create"
        />

        <button
          mat-icon-button
          matSuffix
          class="change-password-dialog__content__form_suffix"
          (click)="$event.preventDefault(); showNewPassword = !showNewPassword"
          [matTooltip]="(showNewPassword ? 'CHANGE_PASSWORD.HIDE' : 'CHANGE_PASSWORD.SHOW') | translate"
          [matTooltipPosition]="'right'"
          type="button"
          tabindex="-1"
        >
          <mat-icon>{{ showNewPassword ? 'visibility' : 'visibility_off' }}</mat-icon>
        </button>

        <mat-error *ngIf="passwordForm.get('password').hasError('usedBefore')">
          {{ 'CHANGE_PASSWORD.ERRORS.USED_BEFORE' | translate }}
        </mat-error>

        <mat-error *ngIf="passwordForm.get('password').hasError('required')">
          {{ 'CHANGE_PASSWORD.ERRORS.REQUIRED' | translate }}
        </mat-error>

        <mat-error
          *ngIf="passwordForm.get('password').hasError('pattern') || passwordForm.get('password').hasError('minlength')"
        >
          {{ 'CHANGE_PASSWORD.ERRORS.INCORRECT_MATCH' | translate }}
        </mat-error>
      </mat-form-field>

      <div class="change-password-dialog__content__form__matches">
        <div
          *ngFor="let match of passwordMatches"
          class="change-password-dialog__content__form__matches_item"
          fxLayout="row"
          fxLayoutAlign="start center"
        >
          <mat-icon
            [ngClass]="{
              'change-password-dialog__content__form__matches_item--checked': matchValue(
                match.regex,
                passwordForm.get('password').value
              )
            }"
          >
            done
          </mat-icon>
          <p>{{ 'CHANGE_PASSWORD.MATCHES.' + match.translate | translate }}</p>
        </div>
      </div>

      <mat-form-field appearance="outline" fxFlex="100">
        <mat-label *ngIf="isOnEditDialog">
          {{ 'CHANGE_PASSWORD.CONFIRM_NEW_PASSWORD' | translate }}
        </mat-label>
        <mat-label *ngIf="!isOnEditDialog">
          {{ 'CHANGE_PASSWORD.CONFIRM_PASSWORD' | translate }}
        </mat-label>
        <input
          matInput
          [type]="showNewPasswordConfirm ? 'text' : 'password'"
          formControlName="confirmPassword"
          required
          autocomplete="off"
        />

        <button
          mat-icon-button
          matSuffix
          class="change-password-dialog__content__form_suffix"
          (click)="$event.preventDefault(); showNewPasswordConfirm = !showNewPasswordConfirm"
          [matTooltip]="(showNewPasswordConfirm ? 'CHANGE_PASSWORD.HIDE' : 'CHANGE_PASSWORD.SHOW') | translate"
          [matTooltipPosition]="'right'"
          type="button"
          tabindex="-1"
        >
          <mat-icon>{{ showNewPasswordConfirm ? 'visibility' : 'visibility_off' }}</mat-icon>
        </button>

        <mat-error *ngIf="passwordForm.get('confirmPassword').hasError('required')">
          {{ 'CHANGE_PASSWORD.ERRORS.REQUIRED' | translate }}
        </mat-error>

        <mat-error *ngIf="passwordForm.get('confirmPassword').hasError('doesNotMatchPassword')">
          {{ 'CHANGE_PASSWORD.ERRORS.CONFIRM_MATCH' | translate }}
        </mat-error>
      </mat-form-field>
    </div>
  </form>

  <div class="change-password-dialog__content__buttons">
    <button
      mat-raised-button
      class="change-password-dialog__content__buttons-button change-password-dialog__content__buttons-button--gray"
      [disabled]="isLoading"
      (click)="matDialogRef.close()"
    >
      {{ 'CHANGE_PASSWORD.BACK' | translate }}
    </button>

    <button
      mat-raised-button
      class="change-password-dialog__content__buttons-button"
      [disabled]="passwordForm.invalid || isLoading"
      (click)="saveNewPassword()"
    >
      {{ 'CHANGE_PASSWORD.NEXT' | translate }}
    </button>
  </div>
</div>
